import apiClient from './config';

export default {
  // Récupérer l'URL d'authentification Google
  getGoogleAuthUrl() {
    return apiClient.get('/firm/calendar/google/auth-url');
  },

  // Récupérer toutes les connexions calendrier
  getConnections() {
    return apiClient.get('/firm/calendar/connections');
  },

  // Synchroniser un calendrier
  syncCalendar(connectionId) {
    return apiClient.post(`/firm/calendar/sync/${connectionId}`);
  },

  // Déconnecter un calendrier
  disconnectCalendar(connectionId) {
    return apiClient.delete(`/firm/calendar/disconnect/${connectionId}`);
  },

  // Mettre à jour les paramètres de synchronisation
  updateSettings(connectionId, settings) {
    return apiClient.patch(`/firm/calendar/settings/${connectionId}`, settings);
  },

  // Activer les notifications en temps réel (webhook)
  enableWebhook(connectionId) {
    return apiClient.post(`/firm/calendar/watch/${connectionId}`);
  },

  // Désactiver les notifications en temps réel (webhook)
  disableWebhook(connectionId) {
    return apiClient.post(`/firm/calendar/unwatch/${connectionId}`);
  },

  // Diagnostic de la synchronisation
  getDebugInfo(connectionId) {
    return apiClient.get(`/firm/calendar/debug/${connectionId}`);
  },

  // Tester l'URL du webhook
  testWebhook() {
    return apiClient.get('/firm/calendar/test-webhook');
  },

  // Renouveler les webhooks qui expirent bientôt
  renewWebhooks() {
    return apiClient.post('/firm/calendar/renew-webhooks');
  },
};
